import InputField from "@components/common/InputField";
import { Email, Phone, AccountCircle } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import type { ProfileFormFieldsProps } from "../types";

const profileFieldIcon = "text-gray-500 !text-[20px]";

const ProfileFormFields: React.FC<ProfileFormFieldsProps> = ({ control, t }) => {
	return (
		<div className="flex flex-col gap-3">
			<div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
				<Controller
					name="firstName"
					control={control}
					render={({ field, fieldState }) => (
						<InputField
							id="profile-firstName"
							placeholder={t("psdaCommon.profile.form.firstName.placeholder")}
							type="text"
							size="medium"
							startIcon={<AccountCircle fontSize="small" className={profileFieldIcon} />}
							error={!!fieldState.error}
							helperText={fieldState.error?.message || " "}
							{...field}
							value={field.value || ""}
						/>
					)}
				/>
				<Controller
					name="lastName"
					control={control}
					render={({ field, fieldState }) => (
						<InputField
							id="profile-lastName"
							placeholder={t("psdaCommon.profile.form.lastName.placeholder")}
							type="text"
							size="medium"
							startIcon={<AccountCircle fontSize="small" className={profileFieldIcon} />}
							error={!!fieldState.error}
							helperText={fieldState.error?.message || " "}
							{...field}
							value={field.value || ""}
						/>
					)}
				/>
			</div>

			<Controller
				name="phoneNumber"
				control={control}
				render={({ field, fieldState }) => (
					<InputField
						id="profile-phoneNumber"
						placeholder={t("psdaCommon.profile.form.phone.placeholder")}
						type="tel"
						size="medium"
						startIcon={<Phone fontSize="small" className={profileFieldIcon} />}
						error={!!fieldState.error}
						helperText={fieldState.error?.message || " "}
						{...field}
						value={field.value || ""}
					/>
				)}
			/>

			<Controller
				name="emailAddress"
				control={control}
				render={({ field, fieldState }) => (
					<InputField
						id="profile-emailAddress"
						placeholder={t("psdaCommon.profile.form.email.placeholder")}
						type="text"
						size="medium"
						startIcon={<Email fontSize="small" className={profileFieldIcon} />}
						error={!!fieldState.error}
						helperText={fieldState.error?.message || " "}
						{...field}
						value={field.value || ""}
					/>
				)}
			/>
		</div>
	);
};

export default ProfileFormFields;
